import { useTranslation } from 'react-i18next'
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/shadcn/select'
import { FilterRow } from '@/components/common/filters/FilterRow'
import { FilterDateRangePicker } from '@/components/common/filters/FilterDateRangePicker'

interface Employee {
  id: string | null
  firstName: string | null
  lastName: string | null
}

interface Props {
  employees: Employee[]
  selectedEmployeeId: string
  dateFrom?: string
  dateTo?: string
  onEmployeeChange: (id: string) => void
  onDateChange: (range: { from?: string; to?: string }) => void
}

export function WalletTransactionFilters({
  employees,
  selectedEmployeeId,
  dateFrom,
  dateTo,
  onEmployeeChange,
  onDateChange,
}: Props) {
  const { t } = useTranslation('wallet')
  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <h2 className="text-lg font-semibold">{t('filters.transactionsTitle')}</h2>
      <FilterRow>
        <FilterDateRangePicker from={dateFrom} to={dateTo} onChange={onDateChange} />
        <Select
          value={selectedEmployeeId || 'all'}
          onValueChange={(v) => onEmployeeChange(v === 'all' ? '' : v)}
        >
          <SelectTrigger className="w-52">
            <SelectValue placeholder={t('filters.allEmployees')} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t('filters.allEmployees')}</SelectItem>
            {employees
              .filter((e) => e.id)
              .map((e) => (
                <SelectItem key={e.id!} value={e.id!}>
                  {[e.firstName, e.lastName].filter(Boolean).join(' ') || e.id}
                </SelectItem>
              ))}
          </SelectContent>
        </Select>
      </FilterRow>
    </div>
  )
}
